import React from 'react';
import PropTypes from 'prop-types';
import { educationLevels } from '../../copy/educationLevels';

const BachelorsDegreeIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>{educationLevels().level6.label}</title>

      <path
        d="M6,374.4l112.4,81.1v177.1c0,4,1.9,7.7,5,10L493,918.1c2.2,1.7,4.8,2.5,7.5,2.5s5.3-0.8,7.5-2.5l236.3-176.2v68.8
		c-36.5,6-64.4,37.7-64.4,75.8v101.4c0,6.9,5.6,12.5,12.5,12.5h128.8c6.9,0,12.5-5.6,12.5-12.5V886.5c0-38.2-27.9-69.8-64.4-75.8
		v-87.4l108.2-80.7c3.2-2.4,5-6.1,5-10V455.5l112.4-81.1c3.3-2.4,5.2-6.1,5.2-10.1c0-4-1.9-7.8-5.2-10.1L507.8,2.8
		c-4.4-3.2-10.3-3.2-14.6,0L6,354.1c-3.3,2.4-5.2,6.1-5.2,10.1S2.7,372,6,374.4z M808.6,886.5v89H704.8v-89
		c0-28.6,23.3-51.9,51.9-51.9S808.6,857.8,808.6,886.5z M500.4,892.5l-357-266.2V473.5l349.7,252.2c2.2,1.6,4.8,2.4,7.3,2.4
		c2.6,0,5.1-0.8,7.3-2.4l236.4-170.5v155.6L500.4,892.5z M857.5,626.3l-88.3,65.8V537.1l88.3-63.7V626.3z M500.4,28.3l465.8,335.9
		L767.8,507.3c-1-1.9-2.4-3.6-4.3-4.8L507.3,335.1c-5.8-3.8-13.5-2.1-17.3,3.6s-2.2,13.5,3.6,17.3l250.6,163.7v4.6L500.5,700.1
		L34.7,364.2L500.4,28.3z"
      />
    </svg>
  );
};

export default BachelorsDegreeIcon;

BachelorsDegreeIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
